import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const handlePrepareData = ({ base_validator, ...rest }) => ({
  base_validator_id: base_validator.key,
  ...rest
});
const Validations = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminRosters()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.validation,
      list: REDUCER_KEY.validations
    }}
    onPrepareData={handlePrepareData}
    config={config}
    permissions={permissions}
  />
);

Validations.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Validations;
